import { render, staticRenderFns } from "./WizardRow.vue?vue&type=template&id=4f20009a&"
import script from "./WizardRow.vue?vue&type=script&lang=js&"
export * from "./WizardRow.vue?vue&type=script&lang=js&"
import style0 from "./WizardRow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports